exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".form-row {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -ms-flex-wrap: wrap;\r\n  flex-wrap: wrap;\r\n  margin-right: -5px;\r\n  margin-left: -5px;\r\n}\r\n\r\n.form-group {\r\n  margin-bottom: 0rem;\r\n}\r\n\r\n.control {\r\n  margin-top: 20px;\r\n  float: none;\r\n /* width: 250px;*/\r\n}\r\n\r\n.control2 {\r\n  float: none;\r\n  /*width: 250px;*/\r\n}\r\n\r\n.control3 {\r\n  margin-top: 25px;\r\n  float: none;\r\n  /*width: 350px;*/\r\n}\r\n\r\n.control4 {\r\n  margin-top: 20px;\r\n  float: none;\r\n  /*width: 500px;*/\r\n}\r\n\r\n.control5 {\r\n  margin-top: 5px;\r\n  margin-right: 10px;\r\n  /*width: 125px;*/\r\n}\r\n\r\n.control6 {\r\n  margin-top: 5px;\r\n  /*width: 125px;*/\r\n}\r\n\r\n.modal-body {\r\n  max-height: 500px;\r\n  overflow-y: auto;\r\n}\r\n\r\n@media (min-width: 768px) {\r\n  .modal-dialog {\r\n    width: 40% !important;\r\n  }\r\n}\r\n\r\nhr {\r\n  border-top: 1px solid #BF9B5F !important;\r\n}\r\n\r\n.heading-bg-color {\r\n  background: #115E67;\r\n  color: #FFF;\r\n  padding: 9px;\r\n  padding-bottom: 5px;\r\n}\r\n\r\n/deep/ .swal-modal {\r\n  width: 900px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/calculation-engine/calculation-engine.component.css
// module id = 339
// module chunks = 1